import { Instagram } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

// VAŽNO: Promenite ove linkove na vaš pravi Instagram profil!
const INSTAGRAM_URL = 'https://www.instagram.com/astroariesstudio/';
const INSTAGRAM_POSTS = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1532968961962-8a0cb3a2d4f5?w=400&h=400&fit=crop',
    caption: 'Retrogradni Merkur - Šta to znači za vas? 🌟',
    link: INSTAGRAM_URL
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=400&h=400&fit=crop',
    caption: 'Pun Mesec u Ovnu - Vreme za akciju! 🔥',
    link: INSTAGRAM_URL
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=400&fit=crop',
    caption: 'Vaša natalna karta otkriva vaš životni put ✨',
    link: INSTAGRAM_URL
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=400&h=400&fit=crop',
    caption: 'Astrološke prognoze za ovu nedelju 🌙',
    link: INSTAGRAM_URL
  }
];

export function InstagramFeed() {
  return (
    <section id="instagram" className="py-20 bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Pratite Nas na Instagramu
          </h2>
          <p className="text-muted-foreground text-lg mb-6">
            Dnevni horoskopi, astrološki saveti i inspiracija
          </p>
          <Button
            size="lg"
            className="gap-2"
            onClick={() => window.open(INSTAGRAM_URL, '_blank')}
          >
            <Instagram className="w-5 h-5" />
            @astroariesstudio
          </Button>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {INSTAGRAM_POSTS.map((post) => (
            <Card
              key={post.id}
              className="group cursor-pointer overflow-hidden hover:shadow-lg transition-all duration-300"
              onClick={() => window.open(post.link, '_blank')}
            >
              <CardContent className="p-0 relative aspect-square">
                <img
                  src={post.image}
                  alt={post.caption}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-4">
                  <p className="text-white text-sm text-center line-clamp-3">
                    {post.caption}
                  </p>
                </div>
                <div className="absolute top-2 right-2 bg-white/90 rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Instagram className="w-4 h-4 text-pink-600" />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <p className="text-muted-foreground mb-4">
            Želite više astrološkog sadržaja?
          </p>
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.open(INSTAGRAM_URL, '_blank')}
          >
            Pogledajte Sve Postove
          </Button>
        </div>
      </div>
    </section>
  );
}